export default "__VITE_ASSET__D103p8Js__"